import { _axios } from "../../../Utils/Axios/axios";

export const addAmountToUserBalance = async (
  userToken: string,
  amount: number
) => {
  return _axios.post(
    "/increase_wallet",
    {
      amount,
    },
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );
};
